import { StringUtils } from 'src/app/services/utils/string.utils';

import { isNullOrUndefined } from 'util';
import { ProductTypeObject } from '../product-type-object.model';
import { ProductStatusObject } from '../product-status-object.model';

export class TreeCardObject {

    private operation: string;
    private tooltip: string;
    private chidren: Array<TreeCardObject>;
    private clicked: boolean;

    constructor(private name: string, private description: string, private info: string, private completed: boolean, private crmId: string, operation: string,
        private status: ProductStatusObject, private dependencies: boolean, private level: number,
        private mapping: number, private id: string, private specId: string,
        private type: ProductTypeObject) {
        this.operation = !isNullOrUndefined(operation) ? operation.trim().toUpperCase() : '';
        this.clicked = false;

        if ((crmId != null) && (status != null)) {
            if (this.completed) {
                this.id = id;
                this.tooltip = ' Provision Process \n Status: COMPLETED \n Id: ' + this.crmId;
            } else {
                this.tooltip = ' Provision Process \n Status: CREATED \n Id: ' + this.crmId;
            }
        } else { this.tooltip = ''; }
        this.chidren = [];
    }


    static create(): TreeCardObject {
        return new TreeCardObject(StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE,
            false, StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE, ProductStatusObject.create(), false, 0, 0,
            StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE, ProductTypeObject.UNKNOWN);
    }

    public getName(): string {
        return this.name;
    }

    public getDescription(): string {
        return this.description;
    }

    public getInfo(): string {
        return this.info;
    }

    public isCompleted(): boolean {
        return this.completed;
    }

    public getCrmId(): string {
        return this.crmId;
    }

    public getOperation(): string {
        return this.operation;
    }

    public getStatus(): ProductStatusObject {
        return this.status;
    }

    public getLevel(): number {
        return this.level;
    }

    public setLevel(level: number): void {
        this.level = level;
    }

    public getTooltip(): string {
        return this.tooltip;
    }

    public hasDependencies(): boolean {
        return this.dependencies;
    }

    public getChildren(): Array<TreeCardObject> {
        return this.chidren;
    }

    public addChildren(treeCardObject: TreeCardObject): void {
        this.chidren.push(treeCardObject);
    }

    public hasChildren() {
        return this.getChildren().length !== 0;
    }

    public getMapping() {
        return this.mapping;
    }

    public setMapping(mapping: number) {
        this.mapping = mapping;
    }

    public getId(): string {
        return this.id;
    }

    public getSpecId(): string {
        return this.specId;
    }

    public setId(id: string) {
        this.id = id;
    }

    public setClicked(clicked: boolean) {
        this.clicked = clicked;
    }

    public isClicked(): boolean {
        return this.clicked;
    }

    public click(): void {
        this.clicked = !this.clicked;
    }

    public getType(): ProductTypeObject {
        return this.type;
    }

    public equals(treeCard: TreeCardObject): boolean {
        return this.name === treeCard.name && this.id === treeCard.id;
    }
}

